export interface QuestDefinitionSimple {
  id: string
  title: string
  target: number
  type: 'daily' | 'weekly' | 'achievement'
  reward: { xp: number; gold: number }
}

// title values are i18n keys — render via t(def.title) in UI components
export const QUEST_DEFINITIONS: QuestDefinitionSimple[] = [
  // ── Original 4 quests ─────────────────────────────────────────────────────
  { id: 'send_units_10',    title: 'QUEST_SEND_UNITS_10',    target: 10, type: 'daily',       reward: { xp: 50,  gold: 100 } },
  { id: 'win_match',        title: 'QUEST_WIN_MATCH',        target: 1,  type: 'achievement', reward: { xp: 150, gold: 200 } },
  { id: 'build_20_towers',  title: 'QUEST_BUILD_20_TOWERS',  target: 20, type: 'daily',       reward: { xp: 60,  gold: 120 } },
  { id: 'win_5_pvp',        title: 'QUEST_WIN_5_PVP',        target: 5,  type: 'weekly',      reward: { xp: 300, gold: 500 } },
  // Tutorial achievement — marked complete by useProgressionStore.completeTutorial().
  // Gated here as an achievement so it shows in ProgressionScreen alongside other
  // achievements but never appears in the daily/weekly quest widget.
  { id: 'complete_tutorial', title: 'QUEST_COMPLETE_TUTORIAL', target: 1, type: 'achievement', reward: { xp: 150, gold: 200 } },

  // Bug-Tracker achievement tiers — progress updated by FeedbackScreen after a
  // report is submitted (server-confirmed count). Each tier requires more confirmed/
  // resolved reports. Tiered approach rewards sustained quality feedback over time.
  // NOTE: 'target' = number of submitted reports for Bronze/Silber, confirmed/resolved for higher tiers.
  { id: 'bug_tracker_bronze',   title: 'QUEST_BUG_TRACKER_BRONZE',   target: 1,  type: 'achievement', reward: { xp: 100,  gold: 150  } },
  { id: 'bug_tracker_silber',   title: 'QUEST_BUG_TRACKER_SILBER',   target: 5,  type: 'achievement', reward: { xp: 250,  gold: 400  } },
  { id: 'bug_tracker_gold',     title: 'QUEST_BUG_TRACKER_GOLD',     target: 10, type: 'achievement', reward: { xp: 500,  gold: 800  } },
  { id: 'bug_tracker_platin',   title: 'QUEST_BUG_TRACKER_PLATIN',   target: 20, type: 'achievement', reward: { xp: 1000, gold: 1500 } },
  { id: 'bug_tracker_diamant',  title: 'QUEST_BUG_TRACKER_DIAMANT',  target: 50, type: 'achievement', reward: { xp: 2500, gold: 4000 } },

  // ── Daily quests (achievable in 1–3 matches, 24h reset) ───────────────────
  { id: 'daily_win_1',      title: 'QUEST_DAILY_WIN_1',      target: 1,  type: 'daily', reward: { xp: 100, gold: 200 } },
  { id: 'daily_towers_5',   title: 'QUEST_DAILY_TOWERS_5',   target: 5,  type: 'daily', reward: { xp: 75,  gold: 150 } },
  { id: 'daily_units_10',   title: 'QUEST_DAILY_UNITS_10',   target: 10, type: 'daily', reward: { xp: 75,  gold: 150 } },
  { id: 'daily_kills_15',   title: 'QUEST_DAILY_KILLS_15',   target: 15, type: 'daily', reward: { xp: 100, gold: 200 } },
  { id: 'daily_upgrade_3',  title: 'QUEST_DAILY_UPGRADE_3',  target: 3,  type: 'daily', reward: { xp: 125, gold: 250 } },

  // ── Weekly quests (longer grind, Monday reset) ────────────────────────────
  { id: 'weekly_wins_5',    title: 'QUEST_WEEKLY_WINS_5',    target: 5,   type: 'weekly', reward: { xp: 500, gold: 800  } },
  { id: 'weekly_units_50',  title: 'QUEST_WEEKLY_UNITS_50',  target: 50,  type: 'weekly', reward: { xp: 400, gold: 600  } },
  { id: 'weekly_kills_100', title: 'QUEST_WEEKLY_KILLS_100', target: 100, type: 'weekly', reward: { xp: 450, gold: 700  } },
  { id: 'weekly_towers_30', title: 'QUEST_WEEKLY_TOWERS_30', target: 30,  type: 'weekly', reward: { xp: 350, gold: 500  } },

  // ── Achievement quests (one-time, no reset) ───────────────────────────────
  { id: 'ach_first_win',    title: 'QUEST_ACH_FIRST_WIN',    target: 1,    type: 'achievement', reward: { xp: 300,  gold: 500  } },
  { id: 'ach_units_500',    title: 'QUEST_ACH_UNITS_500',    target: 500,  type: 'achievement', reward: { xp: 600,  gold: 1000 } },
  { id: 'ach_wins_50',      title: 'QUEST_ACH_WINS_50',      target: 50,   type: 'achievement', reward: { xp: 1000, gold: 2000 } },
  { id: 'ach_kills_1000',   title: 'QUEST_ACH_KILLS_1000',   target: 1000, type: 'achievement', reward: { xp: 800,  gold: 1500 } },
  { id: 'ach_upgrades_100', title: 'QUEST_ACH_UPGRADES_100', target: 100,  type: 'achievement', reward: { xp: 700,  gold: 1200 } },
]

// Quest IDs for daily rotation (used by ProgressionScreen to display daily quests)
export const DAILY_QUEST_IDS = [
  'send_units_10',
  'build_20_towers',
  'daily_win_1',
  'daily_towers_5',
  'daily_units_10',
  'daily_kills_15',
  'daily_upgrade_3',
]

// Quest IDs for weekly rotation (used by useProgressionStore.resetWeeklyQuestsIfNeeded)
export const WEEKLY_QUEST_IDS_EXTRA = [
  'weekly_wins_5',
  'weekly_units_50',
  'weekly_kills_100',
  'weekly_towers_30',
]
